import {
  GET_AUTO_RENEWALS_SUCCESS,
  GET_AUTO_RENEWAL_DETAIL_SUCCESS
} from "../actions/types";
const initialState = {
  autoRenewal: {},
  autoRenewalList: [],
  autoRenewalDetail: []
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_AUTO_RENEWALS_SUCCESS:
      return {
        ...state,
        autoRenewalList: action.autoRenewalList
      };

    case GET_AUTO_RENEWAL_DETAIL_SUCCESS:
      return {
        ...state,
        autoRenewalDetail: action.autoRenewalDetail
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/reducers/autoRenewal.js